module.exports = __webpack_public_path__ + "img/pungo.d6c39fcd.svg";